import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Field } from "@/components/checkout/Field";
import { ImageInput } from "./ImageInput";
import { http, errMsg } from "@/lib/api";

const BLANK = { name: "", description: "", price: "", image: "", available: true, category_id: "" };

export const ProductDialog = ({ open, product, categories, defaultCategory, onClose, onSaved }) => {
  const [p, setP] = useState(BLANK);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setP(product ? { ...product } : { ...BLANK, category_id: defaultCategory || categories[0]?.id || "" });
  }, [open, product, defaultCategory, categories]);

  const set = (k) => (e) => setP({ ...p, [k]: e?.target ? e.target.value : e });

  const save = async () => {
    if (!p.name.trim() || p.price === "" || !p.category_id) return toast.error("Completá nombre, precio y categoría");
    setSaving(true);
    const body = { category_id: p.category_id, name: p.name.trim(), description: p.description, price: Number(p.price), image: p.image, available: p.available };
    try {
      if (product) await http.put(`/admin/products/${product.id}`, body);
      else await http.post("/admin/products", body);
      toast.success("Producto guardado");
      onSaved();
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#1C1515] border-[#2E2323] text-amber-50 max-w-md max-h-[92vh] overflow-y-auto" data-testid="product-dialog">
        <DialogHeader className="text-left">
          <DialogTitle>{product ? "Editar producto" : "Nuevo producto"}</DialogTitle>
          <DialogDescription className="text-[#A89F91]">Los cambios se ven al instante en el menú.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <Field label="Nombre" required value={p.name} onChange={set("name")} testid="product-form-name-input" />
          <Field label="Descripción" textarea value={p.description} onChange={set("description")} testid="product-form-description-input" />
          <Field label="Precio ($)" required type="number" value={p.price} onChange={set("price")} testid="product-form-price-input" />
          <label className="block">
            <span className="text-xs text-[#A89F91] font-medium">Categoría</span>
            <select value={p.category_id} onChange={set("category_id")} className="field-dark mt-1.5 w-full rounded-xl px-4 py-3 text-sm" data-testid="product-form-category-select">
              {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </label>
          <ImageInput label="Imagen" value={p.image} onChange={set("image")} testid="product-form-image" />
          <button onClick={save} disabled={saving} data-testid="product-form-save-btn"
            className="w-full py-3.5 rounded-full bg-[#DC2626] hover:bg-[#991B1B] text-white font-bold disabled:opacity-60">
            {saving ? "Guardando..." : "Guardar producto"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
